export function numbers() {
    const video = document.querySelector('.numbers video');
    if (!video) return;

    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    video.pause();
    video.addEventListener('loadedmetadata', () => {
        video.currentTime = video.duration;
    }, { once: true });
}
